import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BorderCard from '../../../../../../components/common/cards/BorderCard';
import { IAnswersGroup } from '../../SingleActiveGameAnswersView';
import QuestionCheckedAnswersGroup from './questionCheckedAnswersGroup/QuestionCheckedAnswersGroup';

interface CheckedAnswersProps {
  answers: IAnswersGroup[];
  isLoading: boolean;
}

const CheckedAnswers = ({ answers, isLoading }: CheckedAnswersProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center">
        <CircularProgress />
      </div>
    );
  }

  if (answers.length === 0) {
    return <h3 className="text-black700 text-base font-bold">{t('singleActiveGame.answers.noAnswersToShow')}</h3>;
  }

  return (
    <BorderCard className="mb-10">
      <h3 className="text-black700 text-base font-bold mb-6">{t('singleActiveGame.answers.usersAnswers')}</h3>

      {answers.map(answersGroup => {
        return <QuestionCheckedAnswersGroup key={answersGroup.question.id} answersGroup={answersGroup} />;
      })}
    </BorderCard>
  );
};

export default CheckedAnswers;
